const mockPaymentMethodsData = [
    {
        "id": 26,
        "holder_name": "John Doe",
        "number": "**** 4242",
        "exp_month": 2,
        "exp_year": 2024,
        "cvc": "***",
        "country": "DE",
        "street_and_number": "Street # 2121",
        "city": "Berlin",
        "postal_code": "21212",
        "is_default": true,
        "status": "active"
    },
    {
        "id": 8,
        "holder_name": "Clark Kent",
        "number": "**** 8431",
        "exp_month": 2,
        "exp_year": 2027,
        "cvc": "***",
        "country": "US",
        "street_and_number": "Test Str. 19",
        "city": "Newyork",
        "postal_code": "60313",
        "is_default": false,
        "status": "active"
    }
]
export default mockPaymentMethodsData;